
<template>
  <div class="w-full md:pl-16">
    <div class="py-10 w-full px-6">
      <h1 class="font-medium text-gray-900 text-3xl mb-6">Lehrkurse</h1>
      <!-- <div
      v-for="category in courseCategories" :key="category.id"
      >
      <template v-if="category.name !== 'Bitte auswählen:'">
        <b-tag class="inline-block mt-8 mr-2">
          {{ category.name }}
        </b-tag>
      </template>
    </div>  -->
    <loading :isLoading="loading"></loading>
    <b-loading :is-full-page="isFullPage" v-model="isLoading" :can-cancel="true"></b-loading>
<!--         <loading-progress class="absolute bottom-20" v-if="isLoading"
          :progress="50"
          :indeterminate='true'
          :counter-clockwise="true"
          :hide-background="false"
          size="50"
          rotate
          fillDuration="2"
          rotationDuration="1"
        />  -->


      <!-- course category -->
      <div v-for="category in courseCategories" :key="category.id">
        <h3 v-if="category.name === 'Bitte auswählen:' || category.name === 'Tutorial' || category.courses.length == 0" class="font-medium text-left text-gray-900 mt-8 mb-6">
        </h3>
        <h3 v-else class="font-bold border-b-4 text-gray-900 mt-8">
          {{ category.name }}
        </h3>

<!--         <div v-if="category.name === 'Bitte auswählen:'" class="card">
          <div class="card-content">
            <p class="title">
              “There are two hard things in computer science: cache invalidation, naming things, and off-by-one errors.”
            </p>
            <p class="subtitle">
              Jeff Atwood
            </p>
          </div>
          <footer class="card-footer">
            <p class="card-footer-item">
              <span>
                View on <a href="https://twitter.com/codinghorror/status/506010907021828096">Twitter</a>
              </span>
            </p>
            <p class="card-footer-item">
              <span>
                Share on <a href="#">Facebook</a>
              </span>
            </p>
          </footer>
        </div> -->
        <!-- all courses in this category -->
        <div class="mx-auto mt-8 md:flex md:flex-wrap flex" >

          <div
          v-for="course in category.courses"
              :key="course.name" 
              class="align-self:flex-start"
          >
            <!-- Collapsed Card BEGIN --
            <div v-if="course.isDraft && course.instructor.id == user.id || !course.isDraft && course.instructor.id !== user.id">
              <div v-if="!course.isProtected || course.isProtected && user.rolle === course.courseProfession">
            <b-collapse  
              
              animation="slide" :open="isOpen">
              
              <template #trigger="props" >
                <div
                class="card px-3 "
                role="button"
                aria-controls="contentIdForA11y3"
                :aria-expanded="props.open">
                    <a class="card-footer-item">Mehr Details</a>
                  </div>
                </template>
                <div class="card">
                  <b-message type="is-info">
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit. Fusce id fermentum quam. Proin sagittis, nibh id hendrerit imperdiet, elit sapien laoreet elit
                  </b-message>
                </div>
              </b-collapse>
            </div>
          </div>
-- Collapsed Card END-->

          <!-- <b-loading :is-full-page="isFullPage" v-model="isLoading" :can-cancel="true"></b-loading> -->

            <!-- course CARD -->
            <router-link
            :to="{ path: '/courses/' + course.id, params: { id: course.id } }"
            v-bind:class="{
              inviteCourseActive: course.isInvite
            }"
            >
            <div v-if="course.isDraft && course.instructor.id == user.id || !course.isDraft && course.instructor.id !== user.id">
            <div v-if="!course.isProtected || course.isProtected && user.rolle === course.courseProfession" class=" px-1 py-2 md:max-w-sm md:mr-5 mb-6"
            v-bind:class="{
              lockedCourse: !course.isPublic && user.role.name == 0,
            }"
            >
            
<!-- NEW CARD ELEMENT BEGIN-->
 
          <div v-if="category.name !== 'Tutorial'" class="card">
   <!--          <div class="card-image">
              <figure class="image is-4by3">
                <img 
                  src="../assets/images/videos-1.png"
                  class="w-full h-full object-cover object-center" 
                  alt="Placeholder image"
                  >
              </figure>
            </div> -->
            <div class="card-content">
            
              
              <div class="content">
                <div> 
                  <h5 class="mb-2 text-sm text-gray-600">
                    {{ course.skill.name }}
                  </h5>
                  <b-tag type="is-success is-light" v-if="course.isPublic && !course.isDraft && !course.isInviteCourse && !course.isInvite" class="mr-2 py-2">Free to use</b-tag>

                  <b-tag type="is-info" v-if="course.isInviteCourse || course.isInvite" class="mr-2 py-2">Only Invite</b-tag>
                  <br>
                  <font-awesome-icon
                      v-if="!course.isPublic"
                      :icon="lockedIcon"
                      class="mr-2 py-2"
                      />
                  <font-awesome-icon
                  v-if="course.isDraft"
                  :icon="lockedIcon"
                  color="orange"
                  class="mr-2 py-2"
                  />
                  <font-awesome-icon
                    v-if="course.noLicence"
                    :icon="lockedIcon"
                    color="blue"
                    class="mr-2 py-2"
                    />
                    <font-awesome-icon
                    v-if="course.isInviteCourse && !course.isInvite"
                    :icon="lockedIcon"
                    color="green"
                    class="mr-2 py-2"
                    />
                    <font-awesome-icon
                    v-if="course.isProtected"
                    :icon="lockedIcon"
                    color="red"
                    class="mr-2 py-2"
                    />
                    <font-awesome-icon
                    :icon="lockedIcon"
                    color="white"
                    class="mr-2 py-2"
                    />
                  <div class="flex items-center">
                    <h3 class="font-medium text-gray-900 mb-3">
                      {{ course.name }}
                    </h3>
                  </div>
              
                </div>
                <!-- <p class="text-gray-600 text-sm">
                {{ course.description.slice(0, 180) }} <i class="text-blue-700">... mehr erfahren</i>
              </p> -->
              <ul class="mt-5">
                <li class="text-gray-600 flex items-center text-xs mb-4">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="icon icon-tabler icon-tabler-clock"
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    stroke-width="1.5"
                    stroke="currentColor"
                    fill="none"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  >
                    <path stroke="none" d="M0 0h24v24H0z" />
                    <circle cx="12" cy="12" r="9" />
                    <polyline points="12 7 12 12 15 15" />
                  </svg>
                  <span class="mx-2">|</span>
                  <p>{{ course.duration }} min</p>
                </li>
                <li class="text-gray-600 flex items-center text-xs mb-4">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="icon icon-tabler icon-tabler-file-horizontal"
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    stroke-width="1.5"
                    stroke="currentColor"
                    fill="none"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  >
                    <path stroke="none" d="M0 0h24v24H0z" />
                    <path d="M16 5v4a1 1 0 0 0 1 1h4" />
                    <path
                      d="M3 7v10a2 2 0 0 0 2 2h14a2 2 0 0 0 2 -2v-7l-5 -5h-11a2 2 0 0 0 -2 2z"
                    />
                  </svg>
                  <span class="mx-2">|</span>
                  <p>{{ course.sections.length }} Kapitel</p>
                </li>
<!--                 <li class="text-gray-600 flex items-center text-xs mb-4">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="icon icon-tabler icon-tabler-calendar-event"
                    width="20"
                    height="20"
                    viewBox="0 0 24 24"
                    stroke-width="1.5"
                    stroke="currentColor"
                    fill="none"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  >
                    <path stroke="none" d="M0 0h24v24H0z" />
                    <rect x="4" y="5" width="16" height="16" rx="2" />
                    <line x1="16" y1="3" x2="16" y2="7" />
                    <line x1="8" y1="3" x2="8" y2="7" />
                    <line x1="4" y1="11" x2="20" y2="11" />
                    <rect x="8" y="15" width="2" height="2" />
                  </svg>
                  <span class="mx-2">|</span>
                  <p></p>
                </li> -->
                </ul>
                  <!--          // Tags, labels       
                    <a href="#">#css</a> <a href="#">#responsive</a>
                    <br>
                    <time datetime="2016-1-1">11:09 PM - 1 Jan 2016</time> -->
                  </div>
                  <div class="media">
                    <div class="media-left">
                      <figure class="image is-24x24">
                        <img class="h-full w-full rounded-full overflow-hidden shadow" src="http://www.gravatar.com/avatar/3b3be63a4c2a439b013787725dfce802?d=identicon" alt="Placeholder image">
                      </figure>
                    </div>
                    <div class="media-content">
                      <p class="title is-6">{{ course.instructor.firstName }} {{ course.instructor.lastName }}</p>
                      <p class="subtitle is-6">{{ course.instructor.profession }}</p>
                    </div>
                  </div>
                  <span class="flex items-center justify-center p-2 mr-2">
                  <div  class="buttons">
                  <router-link 
                  :to="{ path: '/invite/' + course.id, params: { id: course.id } }"             
                  v-bind:class="{
                  inviteCourse: course.isInvite,
                  }">
                  <b-button type="is-info is-light" expanded v-if="course.isInvite" class="font-medium text-gray-900 mb-3">
                    <font-awesome-icon
                    v-if="course.noLicence"
                    :icon="lockedIcon"
                    color="blue"
                    class=""
                    />
                    Einladung Erforderlich
                  </b-button>
                  <b-button type="is-info is-light" expanded v-if="course.isInviteCourse && !course.isInvite" class="font-medium text-gray-900 mb-3">
                    <font-awesome-icon
                    :icon="lockedIcon"
                    color="green"
                    class=""
                    />
                    Einladung Erforderlich
                  </b-button>
                </router-link>
                <b-button type="is-text" v-if="!course.isInviteCourse && !course.isInvite"></b-button>
              </div>
              <!-- <a class="your-link-styles-here" href="#">
              <b-collapse :open="false" aria-id="contentIdForA11y1">
                    <template #trigger="props">
                        <b-button
                            label="Mehr Infos"
                            type="is-primary"
                            aria-controls="contentIdForA11y1"
                            :aria-expanded="props.open"
                            />
                    </template>
                    <div class="notification">
                        <div class="content">
                            <h3>
                                Subtitle
                            </h3>
                            <p class="text-gray-600 text-sm">
                              {{ course.description.slice(0, 180) }} <i class="text-blue-700">... mehr erfahren</i>
                            </p>
                        </div>
                    </div>
                </b-collapse>
              </a> -->
                </span>
                <b-taglist v-if="course.courseProfession">
                  <b-tag>
                    {{ course.courseProfession }}
                  </b-tag>
                </b-taglist>
            </div>
          </div>
        </div>
        <!-- NEW CARD END-->
      </div>
    </router-link>
  </div>
</div>
      <!-- Rolle für User div beendet -->

      </div>
    </div>

  </div>
</template>


<script>
import gql from "graphql-tag";
import { mapState } from "vuex";
//import { GraphQLClient } from 'graphql-request';

import { library } from "@fortawesome/fontawesome-svg-core";
import { faLock } from "@fortawesome/free-solid-svg-icons";
library.add(faLock);

import Loading from '@/components/Loading.vue';

export default {
  name: "HelloWorld",
  components: {
    Loading,
  },
  data: function () {
    return {
      user: JSON.parse(localStorage.getItem("user"))
        ? JSON.parse(localStorage.getItem("user"))
        : { role: { name: 0 } },
      lockedIcon: "fas fa-lock",
      courseCategories: [],
      moduleCategories: [],
      // course: [],
      isInvite: true,
      noLicence: false,
      loading: false,
      isLoading: false,
      isFullPage: true,
      isOpen: false,
      next: {},
      API_URL:
      process.env.NODE_ENV == "production"
        ? process.env.VUE_APP_STRAPI_API_URL
        : "localhost:1338",
    };
    
  },
mounted(){
  // this.userIsNotInCourse()
  //this.open()
  console.log("courseCategories", this.courseCategories)
  this.courseCategories.forEach((course) => {
      course.isCollapsed = false;
    });
},
  // computed: {
  //   ...mapState({
  //     courseCategories: "courseCategories",
  //   }),
  // },
  apollo: {
/*     course: {
      query: gql`
        query{
          course(id: $id) {
            id
            name
            users_permissions_users{
            id
            username
            email
            }
            instructor {
                id
                firstName
                lastName
                email
                profession
              }
          }
        }
      `,
      variables() {
        return {
          id: this.course.id,
        };
      },
    }, */
    courseCategories: {
      isLoading: true,
      query: gql`
        query {
          courseCategories {
            id
            name
            courses {
              id
              name
              description
              isPublic
              isInvite
              isInviteCourse
              noLicence
              isProtected
              isDraft
              courseProfession
              duration
              skill {
                name
              }
              instructor {
                id
                firstName
                lastName
              }
              sections {
                name
                description
                modules {
                  name
                  description
                  licence
                  iFrame_URL
                }
              }
            }
          }
        }
      `,
    },
    moduleCategories: {
      isLoading: true,
      query: gql`
        query {
          moduleCategories {
            name
            modules {
              id
              name
              description
              licence
              iFrame_URL
              media {
                name
                mime
                url
              }
            }
          }
        }
      `,
    },
    
/*          // watchLoading will be called whenever the loading state changes
     watchLoading (isLoading, countModifier) {
      // isLoading is a boolean
      // countModifier is either 1 or -1
          isLoading += countModifier
    console.log('Global loading', isLoading, countModifier)
    },  */
  },
  methods: {
    // toggleCollapse(course) {
    //   console.log("toggleCollapse", course)
    //   course.isCollapsed = !course.isCollapsed;
    //   console.log("after toggleCollapse", course)
    // },
    toggleCollapse() {
    this.open = !this.open;
    },
    isCourseCollapsed(course) {
      return course.isCollapsed;
    },
    // async fetchData() {
    //   this.loading = true;

    //   try {
    //     // Initialize your GraphQL client
    //     const client = new GraphQLClient('http://localhost:1338/graphql');

    //     // Define your GraphQL query
    //     const query = `
    //     query {
    //       courseCategories {
    //         id
    //         name
    //         courses {
    //           id
    //           name
    //           description
    //           isPublic
    //           isInvite
    //           isInviteCourse
    //           noLicence
    //           isProtected
    //           isDraft
    //           courseProfession
    //           duration
    //           skill {
    //             name
    //           }
    //           instructor {
    //             id
    //             firstName
    //             lastName
    //           }
    //           sections {
    //             name
    //             description
    //             modules {
    //               name
    //               description
    //               licence
    //             }
    //           }
    //         }
    //       }
    //     }
    //     `;

    //     // Execute the GraphQL query
    //     const data = await client.request(query);

    //     // Process the response data as needed
    //     console.log(data);

    //     this.loading = false;
    //   } catch (error) {
    //     // Handle any errors
    //     console.error(error);
    //     this.loading = false;
    //   }
    // },

/*   openLoading() {
    this.isLoading = true
    setTimeout(() => {
        this.isLoading = false
    }, 3 * 1000)
    
  }, */
  open() {
    const loadingComponent = this.$buefy.loading.open({
        container: this.isFullPage ? null : this.$refs.element.$el
    })
    setTimeout(() => loadingComponent.close(), 1.5 * 1000)
  },
 /*    userIsNotInCourse() {
      console.log("course", this.course)
        console.log("user_permissions_users", this.course.users_permissions_users.some((p) => p.email === this.user.email))
    if (this.course.users_permissions_users.some((p) => p.email === this.user.email)) {
        this.userInvited = true
        this.isActiveHint = false
        this.isActiveHintInvited = true
        console.log("user invited:", this.userInvited)
    }
    if(this.user.user_permissions.some((p) => p.key === "super_admin" )){
      console.log("Dieser User hat Super_admin Kräfte")
      this.superAdmin = true
    }
  }, */
    isInviteActive(){
      console.log("Tja das war wohl nix")
    },
    add(event) {
      event.target.className += ' disabled'
    },
    countlicence(){
      let response = this.moduleCategories
      console.log("res", response)
      
      var keyCountCourses = Object.keys(response).length
      console.log("keyCountCourses", keyCountCourses)
      var ObjectX = Object.keys(response)
      console.log("ObjectX", ObjectX)
      
      this.next = JSON.stringify(response)
      this.nextObject = response
      
      ObjectX.forEach((item, keyCountCourses) => {
          let resCourse = this.courseCategories
          console.log("course name", resCourse)
          var keyCountCoursesAll = Object.keys(resCourse).length
          console.log("keyCountCoursesAll", keyCountCoursesAll)
          console.log("All Courses", resCourse[0].courses)

          console.log("keyCountCourses",keyCountCourses)
          console.log("response keyCount",response[keyCountCourses].modules.length)
          var ObjectModules = response[keyCountCourses].modules
          console.log("ObjectModules", ObjectModules)
          var keyCountCourseModules = response[keyCountCourses].modules.length
          
          ObjectModules.forEach((item, index) => {
            console.log(keyCountCourseModules)
                
                 //console.log("userObj1 collection count", item)
                 ObjectX.push({"id":keyCountCourses, "licence":this.nextObject[Object.keys(this.nextObject)[keyCountCourses]].modules[index].licence});
               

              })
               // console.log("repoItem", this.nextObject[Object.keys(this.nextObject)[index]].modules[index].licence)
              });
//this.courseCategories[i].courses[i].sections[i].modules[i].licence

    },
  },
    // need this to show loading for results (only works with search option)
 /*    ...mapActions(['fetchSearchResult']),
                    async getRecipes(e) {
                        this.loading = true
                        e.preventDefault()
                        this.fetchSearchResult(this.search).then(result => {
                            result;
                            this.loading = false
                        })
                    } */
  
    computed: {
    ...mapState({
/*       courseCategories: "courseCategories",
      usersCourses: "usersCourses",
      moduleCategories: "moduleCategories" */
    }),
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@import url("https://unpkg.com/tailwindcss@^2/dist/tailwind.min.css");
body {
  font-family: "Lato", sans-serif;
}
.lockedCourse {
  /* background-color: rgba(0, 0, 0, 0.05); */
  pointer-events: all !important;
}
.inviteCourse {

  pointer-events: all !important;
  cursor: pointer;
}
.inviteCourseActive {

  pointer-events: all !important;
}
.checkbox:checked {
  border: none;
}
.checkbox:checked + .check-icon {
  display: flex;
}
.color-blue {
  color: #0047ab;
}
.collapsed-card {
  /* Styles for the collapsed card */
}
</style>
